import PropTypes from 'prop-types';
import React from 'react';

import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';
import SvgIcon from '../SvgIcon';

const ArrowDownIcon = React.forwardRef(({ height, stroke, viewBox, width }, ref) => (
    <SvgIcon ref={ref} width={width} height={height} viewBox={viewBox}>
        <path
            fill="none"
            fillRule="evenodd"
            stroke={stroke}
            strokeWidth="2"
            d="M1.25 1.021L8 8.745 14.75 1.021"
        />
    </SvgIcon>
));

ArrowDownIcon.propTypes = {
    height: PropTypes.string,
    stroke: PropTypes.string,
    viewBox: PropTypes.string,
    width: PropTypes.string,
};

ArrowDownIcon.defaultProps = {
    height: '10',
    stroke: MIGRATED_COLORS.grey,
    viewBox: '0 0 16 10',
    width: '16',
};

ArrowDownIcon.displayName = 'ArrowDownIcon';

export default ArrowDownIcon;
